import type { FileDto } from '@api/dto/gql-helpers.generated';
import { useCallback, useEffect } from 'react';

import { MsgFileDownload } from '@components/toast';

import type { NotificationSubscriptionResultPayload } from '@system/app';
import { NotificationEvents, useApp } from '@system/app';

import { isObject } from '@utils/typeGuard';

export function useExportFileSuccess() {
  const { notification, flags, toast } = useApp();

  const maintenance_mode = flags?.find(
    item => item.name === 'maintenance_mode',
  );

  const isMaintenanceMode = maintenance_mode?.value === 'on';

  const messageExportSuccess = useCallback(
    (payload: NotificationSubscriptionResultPayload) => {
      const { data } = payload;

      if (
        isObject(data) &&
        'args' in data &&
        isObject<FileDto>(data?.args, ['link']) &&
        (data.args.link || data.args.download_link)
      ) {
        toast.success(
          <MsgFileDownload
            title={data.message ?? 'Файл успешно сформирован'}
            downloadLink={data.args.download_link ?? data.args.link}
            description={data.args.description ?? ''}
          />,
          { autoClose: 30000, closeOnClick: false },
        );
      }
    },
    [toast],
  );

  useEffect(() => {
    if (!isMaintenanceMode) {
      const handlerLink = notification.subscribe(
        NotificationEvents.messageSuccessExportFile,
        messageExportSuccess,
      );
      return () => {
        notification.unsubscribe(
          NotificationEvents.messageSuccessExportFile,
          handlerLink,
        );
      };
    }
  }, [isMaintenanceMode, notification, messageExportSuccess]);

  return null;
}
